import { combineReducers } from 'redux';

import Context from 'redpoints-connector-common/model/Context';

import { getTestPurchaseValidQueryParamsHelper } from '../../../pages/Tasks/TestPurchase/testPurchaseFiltersHelpers';
import completeEvidence from './completeEvidence';
import delayLink from './delayLink';
import discardedReasons from './discardedReasons';
import discardEvidence from './discardEvidence';
import filters from './filters';
import * as fromDomains from './filters/domains';
import * as fromFilterSelected from './filters/selected';
import linkInfo from './linkInfo';

const testPurchase = combineReducers({
  completeEvidence,
  delayLink,
  discardedReasons,
  discardEvidence,
  filters,
  linkInfo,
});

export default testPurchase;

const getTestPurchase = state => state.tasks.testPurchase;

export const getTestPurchaseDiscardedReasons = state =>
  getTestPurchase(state).discardedReasons.response.data ?? null;

export const getTestPurchaseDiscardedReasonsHasError = state => {
  const error = getTestPurchase(state).discardedReasons.error;
  return Object.keys(error).length > 0;
};

export const getTestPurchaseDiscardedReasonsIsLoading = state =>
  getTestPurchase(state).discardedReasons.isLoading;

export const getTestPurchaseDomainsTreeData = state =>
  fromDomains.getTestPurchaseDomainsTreeData(
    getTestPurchase(state).filters.domains
  );

export const getTestPurchaseDomainsAvailableIds = state =>
  fromDomains.getTestPurchaseDomainsAvailableIds(
    getTestPurchase(state).filters.domains
  );

export const getTestPurchaseDomainsIsLoaded = state =>
  !getTestPurchase(state).filters.domains.isLoading &&
  getTestPurchase(state).filters.domains.response.status != null;

export const getTestPurchaseValidQueryParams = (state, queryParams) => {
  const {
    availableDomainPlatformIds,
    availableDomainIds,
  } = getTestPurchaseDomainsAvailableIds(state);

  return getTestPurchaseValidQueryParamsHelper({
    availableDomainIds,
    availableDomainPlatformIds,
    queryParams,
  });
};

export const getTestPurchaseFiltersFromQueryParams = (state, queryParams) => {
  const {
    domainId = [],
    domainPlatformId = [],
    filterBy = null,
  } = getTestPurchaseValidQueryParams(state, queryParams);

  return {
    domainId,
    domainPlatformId,
    filterBy,
  };
};

export const getTestPurchaseFiltersSelected = state => {
  const { filterBy, domainPlatformId, domainId } = getTestPurchase(
    state
  ).filters.selected;

  const allDomainIds = fromFilterSelected.getTestPurchaseFiltersSelectedAllDomainIds(
    { domainPlatformId, domainId },
    getTestPurchase(state).filters.domains.response.data ?? []
  );

  return {
    allDomainIds,
    domainId,
    domainPlatformId,
    filterBy,
  };
};

export const getTestPurchaseFiltersSelectedTreeData = state =>
  fromFilterSelected.getTestPurchaseFiltersSelectedTreeData(
    getTestPurchase(state).filters.selected
  );

const getTestPurchaseLinkInfo = state =>
  getTestPurchase(state).linkInfo.response.data ?? {};

export const getTestPurchaseLinkInfoAddress = state =>
  getTestPurchaseLinkInfo(state).address ?? {};

export const getTestPurchaseLinkInfoActionIsLoading = state =>
  getTestPurchase(state).delayLink.isLoading ||
  getTestPurchase(state).discardEvidence.isLoading ||
  getTestPurchase(state).completeEvidence.isLoading;

export const getTestPurchaseLinkInfoActionIsSuccess = state =>
  getTestPurchase(state).delayLink.response.status != null ||
  getTestPurchase(state).discardEvidence.response.status != null ||
  getTestPurchase(state).completeEvidence.response.status != null;

export const getTestPurchaseLinkInfoIsLoading = state =>
  getTestPurchase(state).linkInfo.isLoading;

export const getTestPurchaseLinkInfoLinkChannel = (state, getChannelById) => {
  const channelId = getTestPurchaseLinkInfo(state).link?.channelId ?? null;
  if (channelId) {
    return getChannelById(channelId);
  }

  return null;
};

export const getTestPurchaseLinkInfoLinkStatus = state =>
  getTestPurchaseLinkInfo(state).link?.status ?? null;

export const getTestPurchaseLinkInfoLinkId = state =>
  getTestPurchaseLinkInfo(state).link?.linkId ?? null;

export const getTestPurchaseLinkInfoContext = (state, context) => {
  const customerId = getTestPurchaseLinkInfo(state).address?.customerId;

  return customerId != null
    ? Object.assign(new Context(), context, { customerId })
    : context;
};

export const getTestPurchaseLinkInfoLinkIsReopened = state =>
  getTestPurchaseLinkInfo(state).link?.reopened ?? false;

export const getTestPurchaseLinkInfoLinkType = state =>
  getTestPurchaseLinkInfo(state).link?.linkType ?? null;

export const getTestPurchaseLinkInfoLinkUrl = state =>
  getTestPurchaseLinkInfo(state).link?.url ?? null;

export const getTestPurchaseLinkInfoPriority = state =>
  getTestPurchaseLinkInfo(state).link?.priority ?? null;

export const getTestPurchaseLinkInfoEvidence = state =>
  getTestPurchaseLinkInfo(state).evidence ?? null;

export const getTestPurchaseLinkInfoEvidencesUrl = state =>
  getTestPurchaseLinkInfoEvidence(state)?.evidencesUrl ?? [];
